module.exports = "/static-assets/_next/static/images/mind-blown-82e353a05706423b25a22fb52c2784af.png";